import styled from 'styled-components'
import {Link as LinkR} from 'react-router-dom'
import {Link as LinkS} from 'react-scroll'

export const Nav = styled.nav`{
    background: #fff;
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    font-size: 1rem;
    top: 0;
    z-index: 10;
    box-shadow: 0 20px 20px -20px rgba(0,0,0,.5);

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
}`

export const NavbarContainer = styled.div`{
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
}`

export const NavLogo = styled(LinkR)`{
    color: #000;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
}`

export const MobileIcon = styled.div`{
    display: none;
    
    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #000;
    }
    
}`

export const NavMenu = styled.ul`{
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 768px) {
        display: none;
    }
}`

export const NavItem = styled.li`{
    height: 80px;
}`

export const NavLinks = styled(LinkS)`{
    color: #000;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    &:active{
        border-bottom: 3px solid #01bf71;
    }

    &:hover{
        border-bottom: 3px solid #01bf71;
        box-shadow: 0 20px 20px -20px rgba(0,0,0,.5);
        background: #FCFCFC;
    }
}`

export const ImgWrapper = styled.div`{
    max-width: 746px;
    height: 100%;
}`

export const Img = styled.img`{
    width: 33%;
    margin-top: 0;
    padding-right: 0;

    @media screen and (max-width: 500px) {
        width: 70%;
        margin: 0;
    }
}`

export const SocialMedia = styled.section`{
    max-width: 1100px;
    width: 100%;
}`

export const SocialMediaWrap = styled.div`{
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1100px;
    margin: 40ppx auto 0 auto;

    @media screen and (max-width: 820px) {
        flex-direction: column;
    }
}`

export const SocialIcons = styled.div`{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 240px;
    
}`

export const SocialIconLink = styled.a`{
    font-size: 18px;
    color: #2867B2;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    &:active{
        border-bottom: 3px solid #01bf71;
    }

    
}`